import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { listarCamposApi } from '../api/ListarCamposApi';
import type { ListarCamposResponse } from '../types';

export function useListarCampos(
  relatorioId: string | null,
  options?: Omit<UseQueryOptions<ListarCamposResponse, Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<ListarCamposResponse, Error>({
    queryKey: ['relatorios', 'listar-campos', relatorioId],
    queryFn: () => {
      if (!relatorioId) {
        throw new Error('Relatório não informado.');
      }

      return listarCamposApi(relatorioId);
    },
    enabled: Boolean(relatorioId) && (options?.enabled ?? true),
    ...options,
  });
}
